export const SPECS = {
  CallCartV2FromCheckout: 'specs.ecom.CallCartV2FromCheckout',
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  StopSendingOriginInCheckoutUrl: 'specs.ecom.StopSendingOriginInCheckoutUrl',
  CallCartV2FromCartComponents: 'specs.ecom.CallCartV2FromCartComponents',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  ShowTwoDescriptionLinesOnCartAndCheckout: 'specs.ecom.ShowTwoDescriptionLinesOnCartAndCheckout',
  ShowCheckoutOnEditorPreview: 'specs.ecom.ShowCheckoutOnEditorPreview',
  CouponAlignmentInCartAndCheckout: 'specs.ecom.CouponAlignmentInCartAndCheckout',
  FixCouponErrorInCart: 'specs.ecom.FixCouponErrorInCart',
  UsePartialLineItemUrlInCart: 'specs.ecom.UsePartialLineItemUrlInCart',
  FixCartNavigationOnPreview: 'specs.ecom.FixCartNavigationOnPreview',
  RevampDiscountsInCartAndCheckout: 'specs.ecom.RevampDiscountsInCartAndCheckout',
  ShowCrossedOutPriceOnLineItemLevel: 'specs.ecom.ShowCrossedOutPriceOnLineItemLevel',
  FixImageDimensionsOnCart: 'specs.ecom.FixImageDimensionsOnCart',
  ShowNoAmountWhenNoDeliveryOnCart: 'specs.ecom.ShowNoAmountWhenNoDeliveryOnCart',
  UpdateCartIconsSVGViewer: 'specs.ecom.UpdateCartIconsSVGViewer',
  CheckoutButtonWithHrefInCart: 'specs.ecom.CheckoutButtonWithHrefInCart',
} as const;
